import {ConfigurationApplication} from '@application/Config';
import {FeatureFlag} from '@domain/model/FeatureFlag/FeatureFlag';
import {fetch} from '@infra/api/fetch';

const tradename = ConfigurationApplication.retrieve().tradename;

const getFeatureFlags = async (): Promise<FeatureFlag[]> => {
  try {
    const response = await fetch(`/api/v2/feature-flags/tradename/${tradename}`);
    return response.json();
  } catch (e) {
    return Promise.reject(e);
  }
};

const apiFeatureFlag = {getFeatureFlags};

export {apiFeatureFlag};
